const serverBasePath = '';

export default {
  get(url, params, callback) {
    return axios.get(url, {
      params: params
    })
  },
  post(url, params, headers, callback) {
    return axios.post(url, params, {headers})
  },
  makeApiMethod(source, target, method) {
    let getApiNames = Object.keys(source)
    getApiNames.forEach(apiName => {
      target[apiName] = (params, headers) => {
        return this[method || 'get'](serverBasePath + source[apiName], params, headers)
      }
    })
  }
}
